import axios from 'axios';

import { BKC_URL } from '../constants';

export const customFetchBaseQuery = async ({ url, method, data, headers }) => {
  try {
    const response = await axios({
      url: `${BKC_URL}/${url}`,
      method,
      data,
      headers,
    });

    // Handle 204 (No Content)
    if (response.status === 204) {
      return { data: { status: response.status, content: null } };
    }

    return { data: response.data, status: response.status };
  } catch (error) {
    return {
      error: {
        status: error.response.status,
        data: error.response.data,
      },
    };
  }
};
